import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  DesktopProfilePageTab,
  ProfilePageAccordion,
  ProfilePageTab,
} from "../constants/ProfilePage";

export interface createProfilePageState {
  activeTab: ProfilePageTab;
  expandedAccordion: ProfilePageAccordion | null;
  desktopActiveTab: DesktopProfilePageTab;
}

const initialState: createProfilePageState = {
  activeTab: ProfilePageTab.Information,
  expandedAccordion: null,
  desktopActiveTab: DesktopProfilePageTab.Public,
};

export const createProfilePageSlice = createSlice({
  name: "profilePage",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<ProfilePageTab>) => {
      state.activeTab = action.payload;
    },
    setDesktopActiveTab: (
      state,
      action: PayloadAction<DesktopProfilePageTab>
    ) => {
      state.desktopActiveTab = action.payload;
    },
    setExpandedAccordion: (
      state,
      action: PayloadAction<ProfilePageAccordion | null>
    ) => {
      state.expandedAccordion = action.payload;
    },
    resetProfilePageState: () => initialState,
  },
});

export const {
  setActiveTab,
  setDesktopActiveTab,
  setExpandedAccordion,
  resetProfilePageState,
} = createProfilePageSlice.actions;

export default createProfilePageSlice.reducer;
